<template>
  <component v-bind="{ countryList }" :is="entityTypeMap[entityType]"></component>
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
  name: 'UkBusinessEntityTypeDetails',

  components: {
    Limited: defineAsyncComponent(() =>
      import(
        '@/components/flows/trusted_contacts/uk/UkBusinessEntityTypeDetailsLimitedCompany.vue'
      ),
    ),
    SoleTrader: defineAsyncComponent(() =>
      import('@/components/flows/trusted_contacts/uk/UkBusinessEntityTypeDetailsSoleTrader.vue'),
    ),
    Umbrella: defineAsyncComponent(() =>
      import('@/components/flows/trusted_contacts/uk/UkBusinessEntityTypeDetailsUmbrella.vue'),
    ),
  },

  provide() {
    return {
      entityType: this.entityType,
    }
  },

  props: {
    entityType: {
      type: String,
      require: true,
      default: 'limited',
    },

    countryList: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      name: 'UkBusinessEntityTypeDetails',
      entityTypeMap: {
        limited: 'Limited',
        sole_trader: 'SoleTrader',
        umbrella: 'Umbrella',
      },
    }
  },
}
</script>

<style scoped></style>
